/* Gaveæske-tilkøb i UpCart-kurv-skuffen.
 *
 * Virker både når UpCart tegner skuffen i document og i en Shadow DOM.
 * Placeringen bestemmes af ankeret <div id="ab-giftbox-slot"></div>, som
 * indsættes i UpCart under Custom HTML → "Above footer/add-ons".
 * Mangler ankeret, indsættes blokken før kurvens footer i stedet.
 *
 * Konfiguration kommer fra snippets/ab-giftbox-addon.liquid.
 */
(function () {
  'use strict';

  var CONFIG_ID = 'ab-giftbox-config';
  var STYLESHEET_ID = 'ab-giftbox-stylesheet';
  var CLONED_STYLE_ID = 'ab-giftbox-cloned-styles';
  var SLOT_ID = 'ab-giftbox-slot';
  var BLOCK_CLASS = 'ab-giftbox';

  var WAIT_MS = 5000;
  var POLL_MS = 250;
  var RESET_MS = 1200;

  /* Indsættelsespunkter hvis ankeret mangler. Rækkefølgen er prioriteret.
     Både UpCart V1 og V2 er dækket, fordi butikken kan skifte version. */
  var FALLBACK_SELECTORS = [
    '.upcart-footer',
    '[class*="upcart-public-component"][class*="footer"]',
    '.upcart-addons'
  ];

  var config = readConfig();
  if (!config || !config.variantId) return;

  var warned = false;
  var activeTimer = null;

  /* ---------- konfiguration ---------- */

  function readConfig() {
    var el = document.getElementById(CONFIG_ID);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /* Loftet fra tema-indstillingen, uafhængigt af lager. */
  function settingsMax() {
    var m = parseInt(config.maxQty, 10);
    if (isNaN(m) || m < 1) return 10;
    return m;
  }

  /* ---------- lager ---------- *
   * Varen må ikke kunne oversælges. Tre tilfælde:
   *   - lageret styres ikke          → ingen grænse
   *   - oversalg er tilladt (continue) → ingen grænse
   *   - ellers                        → lagerantallet er grænsen
   */

  var inCartQty = 0;
  var cartLoaded = false;

  function isStockLimited() {
    if (!config.inventoryManaged) return false;
    if (config.inventoryPolicy === 'continue') return false;
    return !isNaN(parseInt(config.inventoryQuantity, 10));
  }

  function stockLimit() {
    if (!isStockLimited()) return Infinity;
    var q = parseInt(config.inventoryQuantity, 10);
    return q > 0 ? q : 0;
  }

  /* Hvor mange der stadig kan lægges i kurven. Det kunden allerede har
     lagt i kurven tæller med, ellers kan man oversælge ved gentagne klik. */
  function remaining() {
    var limit = stockLimit();
    if (limit === Infinity) return Infinity;
    var left = limit - inCartQty;
    return left > 0 ? left : 0;
  }

  /* Det reelle loft på antalsvælgeren. */
  function maxQty() {
    var r = remaining();
    var s = settingsMax();
    if (r === Infinity) return s;
    return Math.min(s, r);
  }

  function cartJsUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + 'cart.js';
    }
    return '/cart.js';
  }

  /* Læser hvor mange af varen der allerede ligger i kurven. */
  function loadCartQty() {
    return fetch(cartJsUrl(), {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var total = 0;
        var items = (cart && cart.items) || [];
        for (var i = 0; i < items.length; i++) {
          if (items[i].variant_id === config.variantId) total += items[i].quantity;
        }
        inCartQty = total;
        cartLoaded = true;
        return total;
      })
      .catch(function () {
        /* Kan kurven ikke læses, antag intet i kurven. Shopify afviser
           alligevel et køb over lageret, og fejlen vises til kunden. */
        inCartQty = 0;
        cartLoaded = true;
        return 0;
      });
  }

  /* ---------- rod og styling ---------- */

  /* UpCart sætter selv window.upcartDocumentOrShadowRoot til enten
     document eller sin shadow root. Vi bruger samme kilde som appen. */
  function getRoot() {
    var r = window.upcartDocumentOrShadowRoot;
    if (r && typeof r.querySelector === 'function') return r;
    return document;
  }

  /* Temaets <link> rammer ikke ind i en shadow root, så den klones derind. */
  function ensureStyles(root) {
    if (root === document) return;
    if (root.querySelector('#' + CLONED_STYLE_ID)) return;

    var link = document.getElementById(STYLESHEET_ID);
    if (!link) return;

    var clone = link.cloneNode(true);
    clone.id = CLONED_STYLE_ID;
    root.appendChild(clone);
  }

  /* ---------- placering ---------- */

  function isMounted(root) {
    return !!root.querySelector('.' + BLOCK_CLASS);
  }

  function findAnchor(root) {
    var slot = root.querySelector('#' + SLOT_ID);
    if (slot) return slot;

    for (var i = 0; i < FALLBACK_SELECTORS.length; i++) {
      var el = root.querySelector(FALLBACK_SELECTORS[i]);
      if (el && el.parentNode) return el;
    }
    return null;
  }

  /* ---------- markup ---------- */

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* Tåler null/undefined, så tomme tema-indstillinger behandles som tom tekst. */
  function trim(s) {
    return String(s == null ? '' : s).replace(/^\s+|\s+$/g, '');
  }

  function buildBlock() {
    var wrap = document.createElement('div');
    wrap.className = BLOCK_CLASS;

    var media = '';
    if (config.image) {
      media = '<div class="ab-giftbox__image">' +
                '<img src="' + escapeHtml(config.image) + '" alt="" loading="lazy" width="56" height="56">' +
              '</div>';
    }

    /* Underteksten er valgfri — er feltet tomt, udskrives elementet slet ikke. */
    var subheading = trim(config.subheading);
    var subtitle = subheading
      ? '<span class="ab-giftbox__subtitle">' + escapeHtml(subheading) + '</span>'
      : '';

    /* Skærmlæsere skal stadig have en label, selv når underteksten er tom. */
    var qtyLabel = subheading || 'Antal';

    wrap.innerHTML =
      media +
      '<div class="ab-giftbox__body">' +
        '<div class="ab-giftbox__top">' +
          '<div class="ab-giftbox__text">' +
            '<span class="ab-giftbox__title">' + escapeHtml(config.heading) + '</span>' +
            subtitle +
          '</div>' +
          '<span class="ab-giftbox__price">' + escapeHtml(config.priceFormatted) + '</span>' +
        '</div>' +
        '<div class="ab-giftbox__controls">' +
          '<div class="ab-giftbox__stepper">' +
            '<button type="button" class="ab-giftbox__minus" aria-label="Færre">&minus;</button>' +
            '<input type="text" class="ab-giftbox__qty" value="1" inputmode="numeric" ' +
              'aria-label="' + escapeHtml(qtyLabel) + '">' +
            '<button type="button" class="ab-giftbox__plus" aria-label="Flere">+</button>' +
          '</div>' +
          '<button type="button" class="ab-giftbox__add">' + escapeHtml(config.buttonLabel) + '</button>' +
        '</div>' +
        '<p class="ab-giftbox__error" hidden></p>' +
      '</div>';

    return wrap;
  }

  /* ---------- antalsvælger ---------- */

  function getQty(block) {
    var input = block.querySelector('.ab-giftbox__qty');
    var n = parseInt(input.value, 10);
    if (isNaN(n) || n < 1) return 1;
    if (n > maxQty()) return maxQty();
    return n;
  }

  function setQty(block, n) {
    var max = maxQty();
    if (isNaN(n) || n < 1) n = 1;
    if (n > max) n = max;

    block.querySelector('.ab-giftbox__qty').value = String(n);
    block.querySelector('.ab-giftbox__minus').disabled = (n <= 1);
    block.querySelector('.ab-giftbox__plus').disabled = (n >= max);
  }

  function bindStepper(block) {
    var input = block.querySelector('.ab-giftbox__qty');

    block.querySelector('.ab-giftbox__minus').addEventListener('click', function () {
      setQty(block, getQty(block) - 1);
    });

    block.querySelector('.ab-giftbox__plus').addEventListener('click', function () {
      setQty(block, getQty(block) + 1);
    });

    /* Tastet input normaliseres først når feltet forlades, så man kan skrive frit. */
    input.addEventListener('blur', function () {
      setQty(block, getQty(block));
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        setQty(block, getQty(block));
        block.querySelector('.ab-giftbox__add').click();
      }
    });

    setQty(block, 1);
  }

  /* ---------- tilføj til kurv ---------- */

  function cartAddUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + 'cart/add.js';
    }
    return '/cart/add.js';
  }

  function addToCart(variantId, quantity) {
    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    }).then(function (res) {
      if (res.ok) return res.json();
      return res.json().then(function (data) {
        throw new Error((data && (data.description || data.message)) || 'Kunne ikke tilføjes.');
      }, function () {
        throw new Error('Kunne ikke tilføjes.');
      });
    });
  }

  /* upcartRefreshCart findes i UpCarts bundle, men er ikke en garanteret
     offentlig kontrakt — derfor eksistenstjek og et event som reserve. */
  function refreshCart() {
    if (typeof window.upcartRefreshCart === 'function') {
      window.upcartRefreshCart();
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
    /* Skuffen kan gentegnes, så vores blok skal muligvis sættes ind igen. */
    watch();
  }

  function showError(block, message) {
    var el = block.querySelector('.ab-giftbox__error');
    el.textContent = message;
    el.hidden = false;
  }

  function clearError(block) {
    var el = block.querySelector('.ab-giftbox__error');
    el.textContent = '';
    el.hidden = true;
  }

  function bindAddButton(block) {
    var button = block.querySelector('.ab-giftbox__add');

    if (config.available === false) {
      button.disabled = true;
      showError(block, 'Ikke på lager lige nu.');
      return;
    }

    button.addEventListener('click', function () {
      if (button.disabled) return;

      clearError(block);
      var quantity = getQty(block);

      /* Låsen forhindrer dobbelt tilføjelse ved hurtige klik. */
      button.disabled = true;

      addToCart(config.variantId, quantity)
        .then(function () {
          button.textContent = config.addedLabel;
          /* Læs kurven igen frem for at regne selv — så er tallet
             autoritativt, også hvis kurven er ændret i en anden fane. */
          return loadCartQty();
        })
        .then(function () {
          setQty(block, 1);
          refreshCart();

          /* Blokken bliver stående, så kunden kan lægge flere oveni —
             medmindre lageret nu er opbrugt, hvor den fjernes. */
          setTimeout(function () {
            if (remaining() <= 0) {
              removeBlock(getRoot());
              return;
            }
            if (button.isConnected) {
              button.textContent = config.buttonLabel;
              button.disabled = false;
            }
          }, RESET_MS);
        })
        .catch(function (err) {
          showError(block, (err && err.message) || 'Kunne ikke tilføjes.');
          button.disabled = false;
        });
    });
  }

  /* ---------- indsættelse og overvågning ---------- */

  /* Flugt med kurvens egen indrykning. I stedet for at gætte en padding
     måles hvor "Til kurven"-knappen starter i forhold til blokkens kant,
     og samme afstand bruges. Så passer det uanset UpCarts indstillinger. */
  function syncSidePadding(root, block) {
    if (typeof block.getBoundingClientRect !== 'function') return;

    var ref = root.querySelector('.upcart-checkout-button-container') ||
              root.querySelector('.upcart-checkout-button') ||
              root.querySelector('.upcart-discount-code-input');
    if (!ref) return;

    var blockRect = block.getBoundingClientRect();
    var refRect = ref.getBoundingClientRect();
    if (!blockRect.width || !refRect.width) return;

    var left = refRect.left - blockRect.left;
    var right = blockRect.right - refRect.right;

    /* Kun troværdige mål bruges — ellers beholdes CSS-standarden. */
    if (left >= 8 && left <= 48) block.style.paddingLeft = Math.round(left) + 'px';
    if (right >= 8 && right <= 48) block.style.paddingRight = Math.round(right) + 'px';
  }

  function render(root, anchor) {
    if (isMounted(root)) return;
    ensureStyles(root);

    var block = buildBlock();

    if (anchor.id === SLOT_ID) {
      anchor.appendChild(block);
    } else if (anchor.parentNode) {
      anchor.parentNode.insertBefore(block, anchor);
    } else {
      return;
    }

    bindStepper(block);
    bindAddButton(block);
    syncSidePadding(root, block);
  }

  function removeBlock(root) {
    var existing = root.querySelectorAll('.' + BLOCK_CLASS);
    for (var i = 0; i < existing.length; i++) {
      if (existing[i].parentNode) existing[i].parentNode.removeChild(existing[i]);
    }
  }

  function tryMount() {
    var root = getRoot();

    /* Vent på kurvdata, så lagergrænsen er kendt før blokken tegnes. */
    if (!cartLoaded) return false;

    /* Er der intet tilbage at tilføje, må blokken ikke vises. */
    if (remaining() <= 0) {
      removeBlock(root);
      return true;
    }

    if (isMounted(root)) return true;

    var anchor = findAnchor(root);
    if (!anchor) return false;

    render(root, anchor);
    return isMounted(root);
  }

  /* Skuffen tegnes asynkront og kan rives ned igen, så vi forsøger både
     ved UpCarts egne events og med en tidsbegrænset polling.
     activeTimer sikrer, at gentagne kald ikke starter parallelle timere. */
  function watch() {
    if (activeTimer !== null) return;
    if (tryMount()) return;

    var deadline = Date.now() + WAIT_MS;

    activeTimer = setInterval(function () {
      if (tryMount()) {
        clearInterval(activeTimer);
        activeTimer = null;
        return;
      }
      if (Date.now() > deadline) {
        clearInterval(activeTimer);
        activeTimer = null;
        if (!warned) {
          warned = true;
          console.warn('[ab-giftbox] Fandt intet indsættelsespunkt i kurv-skuffen.');
        }
      }
    }, POLL_MS);
  }

  /* Ved hver kurvændring genlæses antallet i kurven, når lageret sætter en
     grænse. Fjerner kunden gaveæsker igen, kommer blokken derfor tilbage. */
  function onCartEvent() {
    if (isStockLimited()) {
      loadCartQty().then(watch);
    } else {
      watch();
    }
  }

  function subscribe(name) {
    if (typeof window[name] === 'function') {
      window[name](onCartEvent);
    }
  }

  subscribe('upcartSubscribeCartOpened');
  subscribe('upcartSubscribeCartLoaded');
  subscribe('upcartSubscribeCartUpdated');

  /* Kurvdata hentes kun når lageret faktisk begrænser antallet. */
  if (isStockLimited()) {
    loadCartQty().then(watch);
  } else {
    cartLoaded = true;
    watch();
  }
})();
